var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#069",
    d: "M8 13.73C8 10.568 10.63 8 13.875 8H81.62c3.244 0 5.875 2.567 5.875 5.73v68.54c0 3.165-2.63 5.73-5.875 5.73H13.875C10.63 88 8 85.435 8 82.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.097 74.968V38.844H20.09v36.124zm-6.003-41.056c4.187 0 6.793-2.774 6.793-6.241-.078-3.545-2.606-6.242-6.714-6.242-4.107 0-6.792 2.697-6.792 6.242 0 3.467 2.605 6.24 6.635 6.24zM38.742 74.968h12.006V54.795c0-1.08.079-2.158.396-2.93.867-2.157 2.843-4.392 6.16-4.392 4.345 0 6.083 3.313 6.083 8.17v19.325h12.006V54.255c0-11.096-5.924-16.259-13.823-16.259-6.478 0-9.321 3.62-10.901 6.087h.08v-5.24H38.742c.157 3.39 0 36.125 0 36.125",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;